import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { templates } from '../templates';

interface TemplatePreviewProps {
  selectedTemplate: string;
  onSelect: (templateId: string) => void;
}

export function TemplatePreview({ selectedTemplate, onSelect }: TemplatePreviewProps) {
  return (
    <div className="mb-8">
      <h2 className="text-xl font-semibold mb-4">Choose Template Style</h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {templates.map((template) => (
          <motion.div
            key={template.id}
            className={`relative cursor-pointer rounded-lg overflow-hidden border-2 
              ${selectedTemplate === template.id ? 'border-indigo-600' : 'border-gray-200'}`}
            whileHover={{ scale: 1.02 }}
            onClick={() => onSelect(template.id)}
          >
            <img 
              src={template.preview} 
              alt={template.name}
              className="w-full aspect-[3/4] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-3 text-white">
              <p className="font-medium">{template.name}</p>
            </div>
            {selectedTemplate === template.id && (
              <div className="absolute top-2 right-2 bg-indigo-600 rounded-full p-1">
                <Check className="w-4 h-4 text-white" />
              </div>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  );
}